export const FETCH_FERTILIZERS = '@@hfty-fertilizers/FETCH_FERTILIZERS'
export const ADD_FERTILIZER = '@@hfty-fertilizers/ADD_FERTILIZER'
